// extracted by mini-css-extract-plugin
export var menu = "search-result-sort-menu-module--menu--2WcTj";
export var menuItem = "search-result-sort-menu-module--menuItem--xCn_e";
export var sortText = "search-result-sort-menu-module--sortText--1ZB0K";